import React from 'react'

function CeilinDisOutlet() {
  return (
    <embed src="\pdfs\E1.4.6_Q-DN_Q-DV_Ceiling_displacement_outlet_06.2003-wTC_kr.pdf" width="100%" height="2100px" />
  )
}

export default CeilinDisOutlet